// extracted by mini-css-extract-plugin
export default {"input":"idk-field_input__eQNld","inpInner":"idk-field_inpInner__aNFkz"};